import { useEffect, useState, useMemo } from 'react';
import {
    Alert, Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import { getRequest, postRequest } from 'src/services';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { endpoints } from 'src/utils/axios';
import Iconify from 'src/components/iconify';
import { handleErrorMessages } from 'src/pages/components/errorhanling-formating';
import "./style.css";
import instagramIcon from "../../../../../assets/icons/instagram.png"
import facebookIcon from "../../../../../assets/icons/facebook.png"
import linkedinIcon from "../../../../../assets/icons/linkedin.png"
import youtubeIcon from "../../../../../assets/icons/youtube.png"
import twitterIcon from "../../../../../assets/icons/twitter.png"


export const TestEmailModal = ({ open, onClose, row }) => {
    console.log("🚀 ~ TestEmailModal ~ row:", row)
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const [ loading, setLoading ] = useState(false);
    const [ sharecode, setSharecode ] = useState()
    const NewDocumentSchema = Yup.object().shape({

    });

    const defaultValues = useMemo(
        () => ({

        }),
        []
    );

    const methods = useForm({
        resolver: yupResolver(NewDocumentSchema),
        defaultValues,
    });

    const {
        reset,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;


    // useEffect(() => {
    //     getShareModalData();
    // }, [ open ]);

    const getShareModalData = async (page = 1) => {
        const data = await getRequest(`${endpoints.admin_dashboard.product_updates.newsletter.get_code}/${row?.id}`);
        if (data) {
            console.log("🚀 ~ getShareModalData ~ data:", data)
            setSharecode(data?.payload);
        }
    };



    useEffect(() => {
        reset(defaultValues);
    }, [ reset, defaultValues ]);

    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        const formData = new FormData();
        formData.append('email', data.email);
        try {
            const response = await postRequest(
                `${endpoints.admin_dashboard.product_updates.newsletter.test_image_post_req}/${row?.id}`,
                formData,
                true
            );
            if (response.metadata?.success) {
                reset();
                onClose();
                enqueueSnackbar({
                    variant: 'success',
                    message: response.metadata.message,
                });
            } else {
                handleErrorMessages(response.message || 'An error occurred.');
            }
        } catch (err) {
            console.error('Error:', err);
            handleErrorMessages(err.message || 'Submission failed.');
        } finally {
            setLoading(false);
        }
    });

    return (
        <Dialog
            open={ open }
            onClose={ (event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            } }
            fullWidth
            maxWidth="lg"
            sx={ {
                borderRadius: 'none',
                padding: '60px',
                fontSize: '13px',
                fontFamily: 'arial',
            } }
            transitionDuration={ {
                enter: theme.transitions.duration.shortest,
                exit: theme.transitions.duration.shortest - 80,
            } }
            scroll={ "body" }
        >
            <FormProvider methods={ methods } onSubmit={ onSubmit }>
                <DialogTitle sx={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
                    <span
                        className='cardColor'
                        style={ {
                            padding: '7px', marginLeft: '-25px', fontWeight: '700',
                            backgroundColor: "#F4F6F8",
                            color: '#637381'
                        } }
                    >
                        &nbsp;&nbsp; Test Email Template &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <IconButton onClick={ onClose }>
                        <Iconify icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent >
                    <Box
                        mt={ 1 }
                        rowGap={ 2 }
                        gap={ 2 }
                        display="grid"
                        gridTemplateColumns={ {
                            xs: 'repeat(1, 1fr)',
                        } }
                    >
                        <RHFTextField name="email" label="Receiver Inbox" />
                    </Box>
                    <Box
                        mt={ 2 }
                        display="grid"
                        gridTemplateColumns={ {
                            xs: 'repeat(1, 1fr)',
                        } }
                    >

                        <Alert sx={ { width: 1 } }>
                            <strong>Note:</strong>  The preview maybe different than the actual email recieved by the user due to styling differences in user's email client.
                        </Alert>
                    </Box>

                    <Box
                        mt={ 2 }
                        display="grid"
                        gridTemplateColumns={ {
                            xs: 'repeat(1, 1fr)',
                        } }
                    >
                        <div dangerouslySetInnerHTML={ { __html: row?.body } } />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" color="inherit" onClick={ onClose }>
                        Cancel
                    </Button>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        className='dark-button'
                        loading={ isSubmitting }
                    >
                        Send
                    </LoadingButton>
                </DialogActions>
            </FormProvider>
        </Dialog >
    );
};